export default {
      id: "i-percent-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-percent",
      toString: function () {
        return this.url;
      }
    }